// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-servDescriptionLarge {
  width: 10%;
}

/*table coloring*/
.mat-row:nth-child(odd){
  background-color:#FFF5E3;
  }

/*table coloring*/
.mat-row:nth-child(even){
  background-color:#ffe8bf;
  }
.mat-header-cell {
  background-color: #f89624;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

tr.mat-row {
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/repository/podrobno-server/podrobno-server.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB;;AAEF,iBAAiB;AACjB;EACE,wBAAwB;EACxB;AACF;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".mat-column-servDescriptionLarge {\n  width: 10%;\n}\n\n/*table coloring*/\n.mat-row:nth-child(odd){\n  background-color:#FFF5E3;\n  }\n\n/*table coloring*/\n.mat-row:nth-child(even){\n  background-color:#ffe8bf;\n  }\n.mat-header-cell {\n  background-color: #f89624;\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\ntr.mat-row {\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
